import { css } from 'styled-components';

export const color = {
  backgroundColor: '#fff',
  textColor: '#000',
  message: {
    info: '#3FA5B4',
  },
  filter: {
    backgroundColor: '#9db9c7',
    selectedDateBgColor: '#9db9c7',
    btnHoverBgColor: '#9db9cf',
    iconColor: '#1a84f1'
  },
  refreshControl: {
    playBtnBgColor: '#4BBB94',
    pauseBtnBgColor: '#f0422b',
    refreshBtnBgColor: '#3FA5B4'
  },
  table: {
    backgroundColor: '#D9D9D9',
    backgroundColorDarken: '#b8b8b8',
    borderColor: '#E6E6E6',
    borderTop: '1px solid #49677F',
    borderBottom: '1px solid #49677F',
    headerBorderColor: '#49677F',
    btnBgColor: '#9db9c7',
    btnColor: '#3FA5B4',
    oddRowBgColor: '#fff',
    evenRowBgColor: '#EEF0F4',
    perfRowBgColor: '#fff',
    perfRowColor: '#000',
    perfLinkColor: '#3FA5B4',
    headerLinkColor: '#3FA5B4',
    titleBackgroundColor: '#d9d9d9',
    titleTextColor: '#000',
  }
};

export const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1025px',
  bigDesktop: '1400px'
};

export const space = {
  paddingSmall: '20px',
  leftPadding: '20px',
  lineHeight: '25px'
};

// Iterate through the sizes and create a media template
export const mediaQueries = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${breakpoints[label]}) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});
